<template>
  <v-form v-model="valid" ref="form">
    <v-dialog v-model="dialog" persistent max-width="1024px">
      <v-card>
        <v-card-title class="blue white--text">
          <span class="headline">แสดงรายการบทบาท</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field disabled v-model="editedItem.authority">
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field v-model="editedItem.description">
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select
                  :items="officerList"
                  v-model="editedItem.officers"
                  return-object
                  item-text="username"
                  item-value="id"
                  label="สมาชิก"
                  multiple
                  chips
                  hint="เลือกเจ้าหน้าที่"
                  persistent-hint
                ></v-select>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="grey darken-2 white--text" @click.native="close" :loading="loading">ยกเลิก</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="info white--text" @click.native="update" :disabled="!valid" :loading="loading">บันทึก</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
import swal from 'sweetalert2'

export default {
  props: [ 'dialog', 'item' ],
  data () {
    return {
      loading: false,
      valid: false,
      officerList: [],
      editedItem: {
        officers: []
      },
      fieldRequiredRules: [
        v => !!v || ''
      ]
    }
  },
  created () {
    this.$store.dispatch('officer/list')
      .then(response => {
        this.officerList = response.data
      })
  },
  methods: {
    close () {
      this.$events.emit('closeDialog', 'showDialog')
    },
    update () {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.$store.dispatch('gang/update', this.editedItem)
          .then(response => {
            this.loading = false
            swal({
              title: 'แก้ไขบทบาทเรียบร้อย!',
              type: 'success'
            }).then(response => {
              this.close()
            })
          }).catch(error => {
            this.loading = false
            swal({
              title: 'เกิดข้อผิดพลาด!!',
              type: 'error',
              width: '50%',
              html: `${error.response.data.message}`
            })
          })
      }
    }
  },
  watch: {
    item () {
      this.editedItem = this.item
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/views/gang/show.vue